<div class="modal fade" id="participantAdmitCard" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Send Admit Card</h5>
        <button id="btnclose" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="mb-1">Select Sender Account</p>
         
        <ng-select placeholder="Senders" [(ngModel)]="sender_account">
            <ng-option [value]="user.id" *ngFor="let user of emailSenderResponseModel.value.results; let i = index">{{user.name}}</ng-option>
         </ng-select>
        <!-- <p class="mb-1">Email Subject</p>
        <input type="text" [(ngModel)]="subject" class="mb-2 rounded-0 form-control p-2" placeholder="Email Subject" style="width:100%">
        <p class="mb-1">Email Body</p>
        <textarea type="text" [(ngModel)]="mailBody" class="mb-2 rounded-0 form-control p-2" placeholder="Email Body" style="width:100%">
          </textarea> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="sendAdmitCard()">Send</button>
      </div>
    </div>
  </div>